<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <!-- Fields -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Seção' : 'Cadastrar Seção' }}
            </h4>

            <div class="d-flex align-items-center">
              <div class="ml-2 d-flex align-items-center">
                <label class="mb-0">
                  <b>Status</b>
                </label>
                <CSwitch
                  type="checkbox"
                  color="success"
                  variant="3d"
                  class="mx-2"
                  v-bind="labelIcon"
                  :checked.sync="form.status"
                />
              </div>
            </div>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="12">
                <CRow>
                  <!-- Permissions -->
                  <CCol lg="4">
                    <div class="form-group">
                      <label for="">Permissão de acesso*</label>

                      <Multiselect
                        :value="profileOptions.find(option => option.value == form.profile)"
                        :options="profileOptions"
                        label="label"
                        track-by="value"
                        placeholder="Selecione"
                        @select="(selected) => form.profile = selected.value"
                      />
                    </div>
                  </CCol>

                  <!-- Title -->
                  <CCol lg="8">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      placeholder="Título"
                      :disabled="processing"
                      required
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <!-- Description -->
            <CRow>
              <CCol lg="12">
                <div class="form-group">
                  <label for="mission">Descrição*</label>

                  <TextEditor
                    id="mission"
                    v-model="form.description"
                    type="simpletext"
                    :disabled="processing"
                  />
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12">
                <FileUploader
                  id="popup-image"
                  :uploader-info="uploaderInfo"
                  :enable-multiple="true"
                  :enable-crop-on-uploader="false"
                  :enable-edit-on-api-table="true"
                  :max-files="25"
                  :accept-types="acceptTypes"
                  :extensions="extensions"
                  :medias="form.medias"
                  uploader-type="banner"
                  :disabled="processing"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- SEO -->
        <CCard class="d-none">
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="mb-0">
                SEO
              </h5>
            </div>
          </CCardHeader>

          <CCardBody>
            <FriendlyUrl
              :value="form.slug"
              :based-on="form.title"
              :disabled="processing"
              :entity="$route.params.id"
              field="slug"
              model="sections"
              @change="(value) => form.slug = value"
            />
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import TextEditor from '@/components/ui/TextEditor'
import CardLog from '@/components/ui/CardLog'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/section.service'

export default {
  metaInfo: {
    title: 'Seção',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_restricted_area_sections')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    Multiselect,
    TextEditor,
    CardLog,
    FriendlyUrl
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        title: '',
        description: '',
        slug: '',
        status: true,
        profile: '',
        medias: []
      },
      form: {},
      profileOptions: [
        {
          value: '3',
          label: 'Todos'
        },
        {
          value: '1',
          label: 'Distribuidor'
        },
        {
          value: '2',
          label: 'Representante'
        }
      ],
      acceptTypes: '*',
      uploaderInfo: {
        label: 'Arquivos'
      },
      processing: false,
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            ...data
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        title: this.form.title,
        slug: this.form.slug,
        description: this.form.description,
        status: !!this.form.status,
        profile: this.form.profile,
        medias: this.form.medias.map((media) => media.id)
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Seção foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Seção foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
